<template>
  <div class="carousel" @mousemove="handleMouseMove" @mouseleave="hideButtons">
    <div class="carousel-container" :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
      @transitionend="handleTransitionEnd">
      <div class="carousel-slide" v-for="(slide, index) in clonedSlides" :key="index">
        <img :src="slide.img" :alt="slide.alt">
        <!-- <router-link v-if="index === 1" class="slide-text" to="/solution">
          <div>{{ t('homePage.carousel.getSolution') }}</div>
          <img class="arrow-icon" src="../../assets/homePage/homeCarousel/right_arrow.png" alt="arrow">
        </router-link> -->
      </div>
    </div>
   
    <div class="carousel-button_bg prev" @click="prevSlide" :style="{ opacity: showPrevButton ? '1' : '0' }">
      <img class="carousel-button" src="../../assets/homePage/homeCarousel/arrow_left.png" alt="Previous"
        :style="{ opacity: showPrevButton ? '1' : '0' }">
    </div>
    <div class="carousel-button_bg next" @click="nextSlide" :style="{ opacity: showNextButton ? '1' : '0' }">
      <img class="carousel-button" src="../../assets/homePage/homeCarousel/arrow_right.png" alt="Next"
        :style="{ opacity: showNextButton ? '1' : '0' }">
    </div>
    <div class="carousel-dots">
      <span v-for="(slide, index) in slides" :key="index" :class="['dot', { active: normalizedIndex === index }]"
        @click="setSlide(index)"></span>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { useI18n } from 'vue-i18n'

export default {
  name: 'HomeCarousel',
  setup() {
    const { t, tm } = useI18n()
    const currentIndex = ref(1)
    // 将slides改为computed属性以响应语言变化
    const slides = computed(() => tm('homePage.carousel.slides'))
    const showPrevButton = ref(false)
    const showNextButton = ref(false)
    const timer = ref(null)

    // 修复clonedSlides计算属性
    const clonedSlides = computed(() => {
      const slideData = slides.value
      return [slideData[slideData.length - 1], ...slideData, slideData[0]]
    })

    // 修复normalizedIndex计算属性
    const normalizedIndex = computed(() => {
      return (currentIndex.value - 1 + slides.value.length) % slides.value.length
    })

    const setSlide = (index) => {
      currentIndex.value = index + 1
      resetTimer()
    }

    const nextSlide = () => {
      currentIndex.value++
      resetTimer()
    }

    const prevSlide = () => {
      currentIndex.value--
      resetTimer()
    }

    const handleMouseMove = (e) => {
      const rect = e.currentTarget.getBoundingClientRect()
      const width = rect.width
      const x = e.clientX - rect.left
      
      const leftZone = width * 0.2
      const rightZone = width * 0.8

      showPrevButton.value = x < leftZone
      showNextButton.value = x > rightZone
    }

    const hideButtons = () => {
      showPrevButton.value = false
      showNextButton.value = false
    }

    const resetTimer = () => {
      if (timer.value) {
        clearInterval(timer.value)
      }
      timer.value = setInterval(nextSlide, 2000)
    }

    const handleTransitionEnd = () => {
      if (currentIndex.value >= clonedSlides.value.length - 1) {
        currentIndex.value = 1

        const container = document.querySelector('.carousel-container')
        container.style.transition = 'none'
        container.offsetHeight 
        container.style.transform = `translateX(-${currentIndex.value * 100}%)`
        
        setTimeout(() => {
          container.style.transition = 'transform 0.5s ease-in-out'
        }, 0)
      } else if (currentIndex.value <= 0) {

        currentIndex.value = slides.value.length
        const container = document.querySelector('.carousel-container')
        container.style.transition = 'none'
        container.offsetHeight
        container.style.transform = `translateX(-${currentIndex.value * 100}%)`
        setTimeout(() => {
          container.style.transition = 'transform 0.5s ease-in-out'
        }, 0)
      }
    }

    onMounted(() => {
      resetTimer()
    })

    onUnmounted(() => {
      if (timer.value) {
        clearInterval(timer.value)
      }
    })

    return {
      currentIndex,
      setSlide,
      nextSlide,
      prevSlide,
      t,
      slides,
      showPrevButton,
      showNextButton,
      handleMouseMove,
      hideButtons,
      clonedSlides,
      normalizedIndex,
      handleTransitionEnd
    }
  }
}
</script>

<style scoped>
.carousel {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-container {
  display: flex;
  width: 100%;
  height: 100%;
  transition: transform 0.5s ease-in-out;
}

.carousel-slide {
  min-width: 100%;
  width: 100%;
  flex-shrink: 0;
  position: relative;
}

.slide-text {
  position: absolute;
  left: 4vw;
  top: 70%;
  transform: translateY(-50%);
  color: rgb(231, 225, 225);
  text-decoration: none;
  font-size: 40px;
  font-weight: 300;
  /* 设置字体为正常粗细 */
  padding: 12px 24px;
  gap: 10px;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  /* 垂直居中对齐 */
}

.slide-text>div {
  margin-bottom: 5px;
}

.arrow-icon {
  width: 40px;
  height: 40px;
}

/* .slide-text:hover {
  background-color: rgba(0, 0, 0, 0.7);
} */

.carousel-slide img {
  width: 100%;
  object-fit: contain;
  display: block;
}

.carousel-dots {
  position: absolute;
  bottom: 40px;
  right: 100px;
  left: auto;
  transform: none;
  display: flex;
  gap: 30px;
  z-index: 2;
}

.dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid rgba(239, 138, 66, 0.8);
}

.dot:hover {
  background: rgba(255, 107, 0, 0.8);
}

.dot.active {
  background: var(--primary-color, #ff7f1a);
  box-shadow: 0 0 0 3px rgba(255, 127, 26, 0.18);
}

.carousel-button_bg {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-image: url('../../assets/homePage/homeCarousel/arrow_bg.png');
  width: 50px;
  height: 100px;
  background-size: contain;
  background-repeat: no-repeat;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel-button_bg:hover {
  transform: translateY(-50%) scale(1.1);
}

.carousel-button {
  position: static;
  width: 30px;
  height: 30px;
  z-index: 2;
  opacity: 0;
  transition: opacity 0.3s;
}

.carousel-button[style*='opacity: 1'] {
  pointer-events: auto;
}

.prev {
  left: 0;
}

.next {
  right: 0;
}

/* 大屏幕设备 */
@media screen and (min-width: 1400px) {
  .carousel-dots {
    bottom: 40px;
    right: 100px;
    gap: 35px;
  }

  .dot {
    width: 14px;
    height: 14px;
  }

  .slide-text {
    position: absolute;
    left: 4%;
    top: 70%;
    font-size: 38px;
  }

  .arrow-icon {
    width: 36px;
    height: 36px;
  }

  .carousel-button_bg {
    width: 50px;
    height: 100px;
  }

  .carousel-button {
    width: 20px;
    height: 20px;
  }
}

/* 笔记本电脑 */
@media screen and (max-width: 1399px) {
  .carousel-dots {
    bottom: 36px;
    right: 80px;
    gap: 30px;
  }

  .dot {
    width: 12px;
    height: 12px;
  }

  .slide-text {
    position: absolute;
    left: 3%;
    top: 70%;
    font-size: 28px;
  }

  .arrow-icon {
    width: 30px;
    height: 30px;
  }

  .carousel-button_bg {
    width: 40px;
    height: 80px;
  }

  .carousel-button {
    width: 17px;
    height: 17px;
  }
}

/* 平板设备 */
@media screen and (max-width: 991px) {
  .carousel-dots {
    bottom: 24px;
    right: 40px;
    gap: 25px;
  }

  .dot {
    width: 10px;
    height: 10px;
  }

  .slide-text {
    position: absolute;
    left: 2.5%;
    top: 70%;
    font-size: 20px;
  }

  .arrow-icon {
    width: 24px;
    height: 24px;
  }

  .slide-text>div {
    margin-bottom: 3px;
  }

  .carousel-button_bg {
    width: 30px;
    height: 60px;
  }

  .carousel-button {
    width: 14px;
    height: 14px;
  }
}

/* 手机设备 */
@media screen and (max-width: 767px) {
  .carousel-dots {
    bottom: 16px;
    right: 18px;
    gap: 20px;
  }

  .dot {
    width: 8px;
    height: 8px;
  }

  .slide-text {
    position: absolute;
    left: 2%;
    top: 70%;
    font-size: 16px;
  }

  .arrow-icon {
    width: 18px;
    height: 18px;
  }

  .carousel-button_bg {
    width: 20px;
    height: 40px;
  }

  .carousel-button {
    width: 11px;
    height: 11px;
  }
}

@media screen and (max-width: 600px) {
  .slide-text {
    position: absolute;
    left: 0%;
    top: 70%;
    font-size: 12px;
  }
}
</style>